import smb from './smb/routes';
import skinDiagnostics from './skindiagnostic/routes';
import vto from './vto/routes';
import virtualMakeup from './virtualmakeup/routes';
import perfecttone from './perfecttone/routes';
import onlineserviceaestheticsimulation from './onlineserviceaestheticsimulation/routes';
import onlineserviceskinanalysis from './onlineserviceskinanalysis/routes';
import dynamicfeatures from './dynamicfeatures/routes';

export default [
  smb,
  skinDiagnostics,
  vto,
  virtualMakeup,
  perfecttone,
  onlineserviceaestheticsimulation,
  onlineserviceskinanalysis,
  dynamicfeatures,
];
